module.exports = __webpack_public_path__ + "img/2-cartoon-content.abb32341.jpg";